export interface DebtItem {
  codigo?: string;
  dataTransacao?: string;
  dataVencimento?: string;
  id: string;
  parcelaAtual?: number;
  qtdParcelasAPagar?: number;
  qtdParcelasPagas?: number;
  situacao?: string;
  totalParcelas?: number;
  valor?: number;
  valorComDesconto?: number;
  valorCompra?: number;
  valorDesconto?: number;
  valorPendente?: number;
  vencimento?: string;
}

export interface DebtGroup {
  label: string;
  notice: string;
  items: DebtItem[];
}

const DEBT_COLLECTIONS: Record<string, Pick<DebtGroup, 'label' | 'notice'>> = {
  financiamentos: {
    label: 'Financiamento de faturas ativos',
    notice: 'O financiamento de faturas será considerado no cálculo do acordo.',
  },
  emprestimos: {
    label: 'Financiamento de empréstimos ativos',
    notice: 'O financiamento de empréstimo será considerado no cálculo do acordo.',
  },
  compras: {
    label: 'Financiamento de compras ativos',
    notice: 'O financiamento de compras será considerado no cálculo do acordo.',
  },
  comprasLimite12x: {
    label: 'Financiamento de limite 12x ativos',
    notice: 'O financiamento de limite 12x será considerado no cálculo do acordo.',
  },
};

const asDebtItems = (items?: unknown) =>
  Array.isArray(items) ? (items as DebtItem[]) : [];

export const buildDebtGroups = (source?: object | null): DebtGroup[] => {
  if (!source) return [];

  return Object.entries(source).flatMap(([key, value]) => {
    const collection = DEBT_COLLECTIONS[key];
    const items = asDebtItems(value);

    if (!collection || items.length === 0) return [];

    return [{ ...collection, items }];
  });
};
